import request from './request';

// 登录
export const login = (data) => request.post('/login', data);

// 获取当前管理员信息及权限
export const getProfile = () => request.get('/profile');

// 获取精细化仪表盘数据（支持时间范围）
export const getDashboardDetail = (params) => request.get('/dashboard/detail', { params });

// 管理员管理
export const getAdminList = (params) => request.get('/admins', { params });
export const createAdmin = (data) => request.post('/admins', data);
export const updateAdmin = (id, data) => request.put(`/admins/${id}`, data);
export const deleteAdmin = (id) => request.delete(`/admins/${id}`);
export const changePassword = (id, data) => request.put(`/admins/${id}/password`, data);

// 角色权限
export const getRoles = () => request.get('/roles');
export const getPermissions = () => request.get('/permissions');
export const getRolePermissions = (roleId) => request.get(`/roles/${roleId}/permissions`);
export const assignPermissions = (roleId, permission_ids) => request.put(`/roles/${roleId}/permissions`, { permission_ids });

// 系统配置
export const getSystemConfig = () => request.get('/system-config');
export const updateSystemConfig = (data) => request.put('/system-config', data);
export const syncOfficialAccountMenu = () => request.post('/official-account/menu/sync');

// ========== 充值订单 ==========
export const getRechargeOrders = (params) => request.get('/recharge-orders', { params });
export const getRechargeOrderDetail = (id) => request.get(`/recharge-orders/${id}`);
export const cancelRechargeOrder = (id) => request.put(`/recharge-orders/${id}/status`, { status: 5 });
export const updateRechargeOrderStatus = (id, status) => request.put(`/recharge-orders/${id}/status`, { status });

// ========== 配送订单 ==========
export const getDeliveryOrders = (params) => request.get('/delivery-orders', { params });
export const getDeliveryOrderDetail = (id) => request.get(`/delivery-orders/${id}`);
export const updateDeliveryOrderStatus = (id, status) => request.put(`/delivery-orders/${id}/status`, { status });

// ========== 用户订单统计（保留，独立于订单管理） ==========
export const getUserOrderStats = (params) => request.get('/user-order-stats', { params });

// 用户管理
export const getUsers = (params) => request.get('/users', { params });
export const updateUserRole = (id, role) => request.put(`/users/${id}/role`, { role });
export const deleteUser = (id) => request.delete(`/users/${id}`);
export const getUserRelation = (userId) => request.get(`/users/${userId}/relation`);

// 退桶申请
export const getRefundRequests = (params) => request.get('/refund-requests', { params });
export const processRefund = (id, data) => request.put(`/refund-requests/${id}/process`, data);

// 操作日志
export const getOperationLogs = (params) => request.get('/operation-logs', { params });

// ========== 配送时段管理 ==========
export const getDeliverySlots = () => request.get('/delivery-slots');
export const createDeliverySlot = (data) => request.post('/delivery-slots', data);
export const updateDeliverySlot = (id, data) => request.put(`/delivery-slots/${id}`, data);
export const deleteDeliverySlot = (id) => request.delete(`/delivery-slots/${id}`);

// ========== 派单管理 ==========
export const getDispatchOrders = (params) => request.get('/dispatch/orders', { params });
export const batchSetStock = (order_ids) => request.post('/dispatch/set-stock', { order_ids });
export const assignOrder = (order_id, worker_id) => request.post('/dispatch/assign', { order_id, worker_id });
export const batchAssignOrders = (order_ids, worker_id) => request.post('/dispatch/batch-assign', { order_ids, worker_id });
export const getDeliveryWorkers = () => request.get('/delivery-workers');
export const reassignOrder = (id, delivery_man_id) => request.post(`/delivery-orders/${id}/reassign`, { delivery_man_id });
export const cancelAssign = (order_id) => request.post('/dispatch/cancel-assign', { order_id });

// ========== 空桶台账 ==========
export const getBucketRecords = (params) => request.get('/bucket-records', { params });
export const getBucketDailySummary = (params) => request.get('/bucket-records/daily-summary', { params });

// ========== 绩效统计 ==========
export const getWorkerStats = (params) => request.get('/stats/delivery-workers', { params });

// ========== 通知日志 ==========
export const getNotificationLogs = (params) => request.get('/notification-logs', { params });

// ========== OA 智能客服风控 ==========
export const getOaRiskAlerts = (params) => request.get('/oa-risk/alerts', { params });
export const markOaRiskAlertHandled = (id, data) => request.put(`/oa-risk/alerts/${id}/handled`, data || {});
export const getOaBlocklist = (params) => request.get('/oa-risk/blocklist', { params });
export const blockOaUser = (data) => request.post('/oa-risk/blocklist', data);
export const unblockOaUser = (openid) => request.delete(`/oa-risk/blocklist/${openid}`);
export const searchOaUsers = (params) => request.get('/oa-risk/users/search', { params });

// ========== 商户管理（超级管理员） ==========
export const getShops = (params) => request.get('/shops', { params });
export const getShopDetail = (id) => request.get(`/shops/${id}`);
export const createShop = (data) => request.post('/shops', data);
export const updateShop = (id, data) => request.put(`/shops/${id}`, data);
export const resetShopAdminPassword = (id) => request.post(`/shops/${id}/reset-password`);
export const switchShop = (shopId) => request.post('/switch-shop', { shopId });

// ========== 分账管理（服务商模式） ==========
export const getProfitSharingLogs = (params) => request.get('/profit-sharing/logs', { params });
export const retryProfitSharing = (id) => request.post(`/profit-sharing/retry/${id}`);
export const queryProfitSharing = (id) => request.get(`/profit-sharing/query/${id}`);
export const queryUnsplitAmount = (id) => request.get(`/profit-sharing/unsplit-amount/${id}`);
export const finishProfitSharing = (id) => request.post(`/profit-sharing/finish/${id}`);
export const listProfitSharingReceivers = (params) => request.get('/profit-sharing/receivers', { params });
export const addProfitSharingReceiver = (data) => request.post('/profit-sharing/receivers/add', data);
export const deleteProfitSharingReceiver = (data) => request.post('/profit-sharing/receivers/delete', data);